import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

// Dynamisches Tag Rendering (h1, h2, h3...)
export function Heading({ node, isLiveMode }) {
  const content = node.content || {};
  const text = content.text || 'Neue Überschrift';
  const Tag = content.tag || 'h2';

  // Wir geben dem Tag noch keine harten Inlinestyle-Fonts hier, 
  // das macht später das BaseWidget über den node.style Token!
  return (
    <Tag style={{ margin: 0 }}>
      {text}
    </Tag>
  );
}

registry.register('Heading', {
  label: 'Überschrift',
  icon: 'T',
  category: 'basic',
  component: Heading,
  defaultProps: {
    content: {
      text: 'Füge deine Überschrift ein',
      tag: 'h2'
    },
    style: {
      desktop: {
        color: '#1a2333',
        fontSize: '32px',
        fontWeight: '700',
        marginBottom: '15px'
      }
    }
  },
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Text',
          fields: [
            { name: 'content.text', type: 'text', label: 'Titel' },
            { name: 'content.tag', type: 'select', label: 'HTML Tag', options: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div'] }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Typografie',
          fields: [
            { name: 'style.desktop.color', type: 'color', label: 'Textfarbe' },
            { name: 'style.desktop.fontSize', type: 'text', label: 'Schriftgröße' },
            { name: 'style.desktop.fontWeight', type: 'select', label: 'Stärke', options: ['400', '500', '600', '700', '800'] },
            { name: 'style.desktop.textAlign', type: 'select', label: 'Ausrichtung', options: ['left', 'center', 'right', 'justify'] }
          ]
        }
      ]
    }
  ]
});
